import { service, baseURL, pieviewURL } from "../utils/request.js";
import axios from "axios";
let request = service;
//get
export function getAction(url, params) {
  return request({
    url: url,
    method: 'get',
    params: params,
  })
}
/** AI 申报书识别超时（与页面提示 1～3 分钟对齐，略留余量） */
// export const AI_CHAT_TIMEOUT = 3 * 60 * 1000;

// post
export function postAction(url, data, config = {}) {
  return request({
    url: url,
    method: 'post',
    data: data,
    ...config,
  })
}

/** 智能识别申报书 */
export function postAiChat(data, config = {}) {
  return postAction("/aiAuto/chat", data, {
    // timeout: AI_CHAT_TIMEOUT,
    ...config,
  });
}
// post
export function post1Action(url, data) {
  return request({
    url: url,
    method: 'post',
    data: data,
    headers: { 'Content-Type': "application/x-www-form-urlencoded" }
  })
}
// put
export function putAction(url, data) {
  return request({
    url: url,
    method: 'put',
    data: data,
  })
}
// delete
export function deleteAction(url, params) {
  return request({
    url: url,
    method: 'delete',
    params: params,
  })
}
export function goLogin(data) {
  // 登录
  return request({
    url: "sys/login",
    method: "post",
    data,
    code: "v4",
  });
}

export function LogOut() {
  // 退出登录
  return request({
    url: "/sys/logout",
    method: "get",
    code: "v4",
  });
}

export function getCaptcha(currdatetime) {
  //获取验证码
  return request({
    url: `sys/randomImage/${currdatetime}`,
    method: "get",
    code: "_t=",
  });
}

export function fileUpdate(data) {
  // 文件上传
  return request({
    url: "/sys/common/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    code: "",
  });
}
export function fileUpdates(url, data) {
  // 文件上传
  return request({
    url: url,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    code: "",
  });
}
export function idenfileUpdate(data) {
  // 文件上传
  return request({
    url: "/aiAuto/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    code: "",
  });
}
export function idenfileUpdates(data) {
  // 文件上传
  return request({
    url: "/aiAuto/sys/common/importStudioPDF",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    code: "",
  });
}
export function lxApplyFileList(data) {
  // 遴选报名或修改
  return request({
    url: "lx/lxApply/saveOrUpdate",
    method: "post",
    data,
    code: "",
  });
}

export function lxAddUser(data) {
  //添加角色
  return request({
    url: "/sys/user/lxadd",
    method: "post",
    data,
    code: "",
  });
}

export function lxEditUser(data) {
  //修改角色
  return request({
    url: "/sys/user/lxedit",
    method: "post",
    data,
    code: "",
  });
}

export function lxDeleteUser(data) {
  //删除角色
  return request({
    url: "/sys/user/lxdelete",
    method: "delete",
    params: data,
    code: "",
  });
}

export function lxApplySaveOrUpdate(data) {
  //上传文件
  return request({
    url: "lx/lxApply/saveOrUpdate",
    method: "post",
    data,
    code: "",
  });
}

export function lxApplyApplylist(params) {
  //遴选报名-查询
  return request({
    url: `/lx/lxApply/xxList`,
    method: "get",
    params,
  });
}

export function lxApplyjApplylist(params) {
  //教育局遴选报名-查询
  return request({
    url: `/lx/lxApply/jyjList`,
    method: "get",
    params,
  });
}
export function lxApplytApplylist(params) {
  //教育厅遴选报名-查询
  return request({
    url: `/lx/lxApply/jytList`,
    method: "get",
    params,
  });
}

export function setApplyLevel(data) {
  //设置项目级别（教育局/厅：终审通过后设置省级/市级，applyLevel 1=省级 2=市级）
  return request({
    url: `/lx/lxApply/setApplyLevel`,
    method: "post",
    data,
  });
}

export function lxApplyApplyDelete(data) {
  //遴选报名-删除
  return request({
    url: `lx/lxApply/delete?id=${data.id}&applyId=${data.id}`,
    method: "delete",
    data,
    code: "",
  });
}

export function userLxList(data) {
  //用户列表-查询(非school-role)
  return request({
    url: "/sys/user/lxlist",
    method: "get",
    params: data,
    // code: "",
  });
}
 //用户列表-查询(school-role)
export function teachLxList(data) {
  return request({
    url: "/sys/user/teacherList",
    method: "get",
    params: data,
    // code: "",
  });
}

export function userLxApplyDateView() {
  //教育局-上报时间-显示
  return request({
    url: "/lx/lxApply/applyDateView",
    method: "get",
    // params:data,
    // code: "",
  });
}

export function userLxApplyDateSet(data) {
  //教育局-上报时间-设置
  return request({
    url: "/lx/lxApply/applyDateSet",
    method: "post",
    data,
    code: "",
  });
}

export function userLxExpertDateView() {
  //教育局-评审时间-显示
  return request({
    url: "/lx/lxApply/expertDateView",
    method: "get",
    // params:data,
    // code: "",
  });
}

export function userLxExpertDateSet(data) {
  //教育局-评审时间-设置
  return request({
    url: "/lx/lxApply/expertDateSet",
    method: "post",
    data,
    code: "",
  });
}

export function userCheck(data) {
  //用户添加校验
  return request({
    url: "/sys/duplicate/check",
    method: "get",
    params: data,
    // code: "",
  });
}

export function applyDateView(data) {
  //上报时间显示
  return request({
    url: "/lx/lxApply/applyDateView",
    method: "get",
    params: data,
    // code: "",
  });
}

export function schoolMaxNum(data) {
  //当前登录学校最大允许申报数
  return request({
    url: "/lx/lxSchoolMaxNum/schoolMaxNum",
    method: "get",
    params: data,
    // code: "",
  });
}

export function expertDateView(data) {
  //评审时间显示
  return request({
    url: "/lx/lxApply/expertDateView",
    method: "get",
    params: data,
  });
}

export function lxApplyApplySettingData(data) {
  //获取 教育局-评审设置-作品与专家与学校树结构返回
  return request({
    url: "/lx/lxApply/applySettingData",
    method: "get",
    params: data,
    // code: "",
  });
}

export function schoolNumList(data) {
  //上传学校限制数量列表
  return request({
    url: "/lx/lxSchoolMaxNum/schoolNumList",
    method: "get",
    params: data,
    // code: "",
  });
}

export function lxExpertApplyAdd(data) {
  //教育局-评审设置-绑定专家与作品
  return request({
    url: "/lx/lxExpertApply/add",
    method: "post",
    data,
    // code: "",
  });
}

export function getLxExpertList(data) {
  //教育局-评审设置-获取专家列表
  return request({
    url: `/sys/user/lxAllList`,
    method: "get",
    params: data,
  });
}

export function updatePassword(data) {
  // 修改密码
  return request({
    url: "/sys/user/updatePassword",
    method: "put",
    data,
  });
}

export function schoolNumSet(data) {
  // 给某个学校某个项目设置限制
  return request({
    url: "/lx/lxSchoolMaxNum/schoolNumSet",
    method: "post",
    data,
  });
}
export function lxApplyZjApplyList(params) {
  // 获取专家评审列表
  return request({
    url: `/lx/lxApply/zjApplylist`,
    method: "get",
    params,
  });
}
export function lxExpertApplyReview(data) {
  // 专家评审
  return request({
    url: "/lx/lxExpertApply/evaluate",
    method: "post",
    data,
  });
}
export function resetPasswords(data) {
  // 重置密码
  return request({
    url: "/sys/user/resetPassword",
    method: "put",
    data,
  });
}
export function userLxExport(params) {
  // 导出
  return request({
    url: "/sys/user/lxExportXls",
    method: "GET",
    responseType: "blob",
    params,
  });
}
export function userLxImport(data) {
  // 导入
  return request({
    url: "/sys/user/lxImportExcel",
    method: "post",
    data,
  });
}
export function deleteFile(params) {
  // 删除文件
  return request({
    url: "/lx/lxApply/deleteFile",
    method: "DELETE",
    params,
  });
}
export function lxApplyExportZip(params) {
  // 导出资料
  return request({
    url: "/lx/lxApply/exportZip",
    method: "GET",
    responseType: "blob",
    params,
  });
}
//导出模板
export function lxApplyexportTemplate(params) {
  // 导出资料
  return request({
    url: "/lxBase/exportTemplate",
    method: "GET",
    responseType: "blob",
    params,
  });
}
export function lxApplyexportQlTemplate(params) {
  // 导出资料
  return request({
    url: "/lxBase/exportCombinedTemplate",
    method: "GET",
    responseType: "blob",
    params,
  });
}
export function getFileAccessHttpUrl(avatar, subStr) {
  if (!subStr) subStr = "http";
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar;
    } else {
      // window._CONFIG['staticDomainURL']
      if (avatar && avatar.length > 0 && avatar.indexOf("[") == -1) {
        return pieviewURL + avatar;
      }
    }
  } catch (err) {
    return;
  }
}